
export function selectResponsiveValue( responsiveConfiguration = []) {
  const sortedResponsiveValues = responsiveConfiguration.sort( (a,b) => a.FromWidth > b.FromWidth );
  const width = window.innerWidth;
  const configuration = sortedResponsiveValues.slice(1).reduce( (current,next) => next.FromWidth <= width ? next : current, sortedResponsiveValues[0]);
  return configuration && configuration.value;
}
